import React from 'react';
import i18next from 'i18next';

function Cure() {
    return (
        <>
            {i18next.language === 'ar' ? (
                <>
                    <ol start={1} className='title-list'>
                        <li>
                            <h3>تحليل السلوك التطبيقي</h3>
                        </li>
                    </ol>
                    <h4 id='title'>ما هو برنامج التحليل السلوك التطبيقي</h4>
                    <p>
                        هو نهج علمي لفهم السلوك باستخدام ممارسات مثبتة علميا
                        ومبنية على البراهين. يشير تحليل السلوك التطبيقي إلى
                        مجموعة من المبادئ التي تركز على كيفية تغيير السلوك
                        وكيفية تأثره بالبيئة المحيطة , وكذلك كيفية إحداث فرص
                        للتعلم.
                    </p>
                    <p>
                        يشير مصطلح السلوك أيضاً إلى المهارات والإجراءات الممكن
                        ملاحظتها وقياسها واللازمة للتواصل واللعب ويعد برنامج
                        التحليل السلوك التطبيقي برنامج شامل مبني على مبادئ تحليل
                        السلوك التطبيقي , يعتمد الكثيرين من أنحاء العالم استخدام
                        برنامج التحليل السلوك التطبيقي مع أطفال ذوي اضطراب طيف
                        التوحد من مختلف الفئات العمرية.
                    </p>
                    <h4 id='title'>
                        تساعد التدخلات القائمة على مبادئ تحليل السلوك التطبيقي
                        على
                    </h4>
                    <ul id='last'>
                        <li>زيادة و تحسين مهارات اللغة والتواصل.</li>
                        <li>
                            تحسين الانتباه ، التركيز ، المهارات الاجتماعية
                            والأكاديمية.
                        </li>
                        <li>
                            التقليل والحد من المشكلات السلوكية و السلوكيات الغير
                            مرغوبة.
                        </li>
                    </ul>
                    <p id='list'>
                        كما تحتوي جلسات تحليل السلوك التطبيقي على استخدام العديد
                        من الاستراتيجيات بمرونة لفهم و تغيير السلوك وبالتالي
                        تعديله وذلك عن طريق:
                    </p>
                    <ul id='last'>
                        <li>
                            تصميم البرامج بما يتناسب مع احتياجات الحالة بشكل
                            فردي.
                        </li>
                        <li>
                            تعليم المهارات المهمة والمساندة لمهارات الحياة
                            اليومية.
                        </li>
                        <li>تقديم الجلسات بشكل فردي أو جماعي.</li>
                    </ul>
                    <h4 id='title'>الفئات المستهدفة</h4>
                    <p>
                        يهدف من برنامج التحليل السلوك التطبيقي في مركز التميز
                        تقديم البرنامج لمختلف فئات المجتمع التالية:
                    </p>
                    <h5 id='title'>
                        اولاً : الأطفال ذوي اضطراب طيف التوحد , من خلال إنشاء
                        برنامج فردي مكثف وشامل يشمل
                    </h5>
                    <ul id='last'>
                        <li>تعليم مهارات و سلوكيات جديدة</li>
                        <li>الحفاظ على السلوكيات المناسبة</li>
                        <li>الحد وضبط السلوكيات التداخلية</li>
                    </ul>
                    <h5 id='title'>
                        ثانياً : أهالي الأطفال الذي يعانون من اضطراب طيف التوحد
                    </h5>
                    <ul id='last'>
                        <li>تقديم الاستشارات</li>
                        <li>
                            تدريب الأهالي على البرامج والأهداف المقدمة للأطفال
                            في المركز لتعميمها في البيئات الأخرى
                        </li>
                    </ul>
                    <h5 id='title'>ثالثاً : المختصين في مجال التربية الخاصة</h5>
                    <p>
                        من خلال تقديم دورات مكثفة وتدريبهم على ممارسات التحليل
                        السلوك التطبيقي.
                    </p>
                    <p>
                        على الرغم من قلة عدد المعالجين و المدربين المعتمدين في
                        مجال التحليل السلوك التطبيقي الا ان مركز التميز يحرص على
                        تقديم البرنامج تحت إشراف مختصين معتمدين من بورد محللي
                        السلوك BCBA.
                    </p>
                    <h4 id='title'>أبرز ممارسات تحليل السلوك التطبيقي</h4>
                    <ul id='last'>
                        <li>
                            التدريب المحاولات المنفصلة Discrete Trial Training
                        </li>
                        <li>
                            استراتيجيات خفض السلوك Behavior Reduction Strategies
                        </li>
                        <li>السلوك اللفظي Verbal Behavior</li>
                        <li>
                            التحليل الوظيفي للسلوك Functional Behavior
                            Assessment
                        </li>
                        <li>
                            نظام التواصل بتبادل الصور The Picture Exchange
                            Communication System
                        </li>
                        <li>
                            التدريب على التواصل الوظيفي Functional Communication
                            training
                        </li>
                        <li>التلقين Prompting</li>
                        <li>
                            التدريب في البيئة الطبيعية Natural Environment
                            Training
                            <ul>
                                <li>
                                    برنامج دنفر للتدخل المبكر Early Start Denver
                                    Model
                                </li>
                                <li>
                                    برنامج التدريب على الاستجابة المحورية
                                    Pivotal Response Training
                                </li>
                                <li>التعلیم العرضي Incidental Teaching</li>
                            </ul>
                        </li>
                    </ul>
                    <ol start={2} className='title-list'>
                        <li>
                            <h3 id='title'>علاج النطق واللغة</h3>
                        </li>
                    </ol>
                    <p>
                        الهدف من خدمات علاج النطق واللغة هو تحسين التواصل
                        الاجتماعي والمهارات اللغوية الأخرى وتعديل السلوكيات بحيث
                        يكون الفرد أكثر قدرة على تطوير العلاقات والعمل بشكل فعال
                        في المواقف الاجتماعية والمشاركة في الحياة اليومية.
                        غالبًا ما يتعاون أخصائي النطق و اللغة مع مختصين آخرين
                        لتصميم وتنفيذ خطط علاجية فعالة.
                    </p>
                    <h4 id='title'>
                        الأهداف تستهدف التحديات الأساسية في اضطراب طيف التوحد و
                        تركز على
                    </h4>
                    <ul id='last'>
                        <li>
                            المبادرة في التواصل العفوي عبر الأنشطة الوظيفية ؛
                        </li>
                        <li>الانضمام إلى التفاعلات التواصلية المتبادلة</li>
                        <li>
                            تعميم المهارات عبر الأنشطة والبيئات المختلفة وشركاء
                            التواصل.
                        </li>
                    </ul>
                    <p>
                        العمليات والتسلسلات النمائية للتطور اللغوي تُقدم إطار
                        العمل لتحديد أسس العلاج وتعديل الأهداف وتتبع التقدم.
                        تتخذ التحديات الأساسية لاضطراب طيف التوحد أشكالًا مختلفة
                        حيث يستجيب الفرد للتدخل ويتقدم من خلال مراحل التطور
                        المختلفة من مرحلة ما قبل اللغوية إلى اللغة الناشئة ثم
                        إلى مراحل اللغة المتقدمة.
                    </p>
                    <p>
                        يمكن أن تختلف طريقة التواصل المستخدم أثناء العلاج (على
                        سبيل المثال ،قد تكون لغة منطوقة ، أو الإيماءات ، أو لغة
                        الإشارة ، أو التواصل بالصور ، أو عبر أجهزة توليد الكلام
                        [SGD] ، و / أو اللغة المكتوبة) ، ويمكن استخدام أكثر من
                        طريقة للتواصل في نفس الوقت. أنظمة التواصل متعددة الطرق
                        هي أنظمة فردية تتوافق مع قدرات الشخص وسياق التواصل.
                    </p>
                    <h4 id='title'>الممارسة المتمحورة حول الأسرة</h4>
                    <p>
                        الهدف من الممارسة المتمحورة حول الأسرة هو خلق شراكة بحيث
                        أن تشارك الأسرة بشكل كامل في جميع جوانب رعاية الفرد.
                        يمكن أن تساعد مشاركة الأسر في خدمات الفرد ذوي اضطراب طيف
                        التوحد على تقليل الضغط الذي يعاني منه أفراد الأسرة
                    </p>
                    <p>
                        قد يتخذ الدعم أشكالًا مختلفة في أوقات مختلفة و قد يشمل
                        تعاون و تنسيق الخدمات للأسرة ، الحصول على المراجع
                        والمعلومات ، تعليم الأسرة أو شركاء التواصل الأخرين على
                        الاستراتيجيات و المهارات المهمة للتواصل ، توفير فرص
                        التعلم ، والدفاع عن الأسرة أو معها.
                    </p>
                    <p>
                        طرق العلاج هي تقنيات أو أنظمة دعم أخرى يمكن لأخصائي
                        النطق و اللغة استخدامها بالاقتران مع أو أثناء تنفيذ
                        العلاجات المختلفة. على سبيل المثال ، يمكن لأخصائي النطق
                        واللغة استخدام الإرشادات المستندة إلى الفيديو في
                        التدخلات بوساطة الأقران لمعالجة المهارات الاجتماعية
                        والسلوكيات المستهدفة الأخرى.
                    </p>
                    <p>
                        عند اختيار طريقة التواصل، فإن أخصائي النطق واللغة
                        يختارها حسباً لهدف التدخل و مرحلة تطور الطفل اللغوي. على
                        سبيل المثال ، قد لا تكون الطريقة المختارة لتواصل شخص في
                        مرحلة اللغة الناشئة مناسبة لشخص في مرحلة ما قبل اللغة.
                    </p>
                    <p>
                        <strong>التواصل المعزز والبديل (AAC)**</strong>جدول
                        الأنشطة والدعم البصري
                        <strong>
                            <strong>التعليمات المستندة إلى الكمبيوتر</strong>
                        </strong>
                        التعليمات المستندة على الفيديو**
                    </p>
                    <p>
                        تختلف مناهج العلاج في الطريقة المستخدمة عند تحديد
                        الأهداف title فهي تتراوح بين التجربة المنفصلة ، والمناهج
                        السلوكية التقليدية للبراغماتية الاجتماعية، والمناهج
                        النمائية
                    </p>
                    <ol start={3} className='title-list'>
                        <li>
                            <h3 id='title'>العلاج الوظيفي</h3>
                        </li>
                    </ol>
                    <p id='list'>
                        يعتبر العلاج الوظيفي أحد التخصصات الطبية الهامة في تأهيل
                        و تطوير المهارات الوظيفية و الحركية والحسية للأفراد ذوي
                        طيف التوحد. فالجمعية الأمريكية للعلاج الوظيفي توضح بأن
                        ممارسي العلاج الوظيفي لديهم المهارة الإكلينيكية والقدرات
                        التحليلية اللازمة لاستخدام تطبيقات واستراتيجيات علاجية
                        قائمة على الأدلة الرصينة لمعالجة:
                    </p>
                    <ul id='last'>
                        <li>التنظيم الذاتي</li>
                        <li>المشاكل الحسية</li>
                        <li>التأخر النمائي الحركي</li>
                        <li>مهارات التكيف</li>
                        <li>الاستقلالية في أداء أنشطة العناية اليومية</li>
                        <li>القدرات الحركية الدقيقة (مهارات اليد)</li>
                        <li>المشاركة الاجتماعية</li>
                        <li>الانتقائية بالأكل</li>
                        <li>التكامل البصري الحركي</li>
                    </ul>
                    <p>
                        كما أن طيف التوحد هو اضطراب نمائي عصبي يلازم الشخص منذ
                        الطفولة المبكرة ويستمر معه طوال فترة حياته
                    </p>
                    <p>
                        فأخصائي العلاج الوظيفي يعمل في بيئات متعددة: كمراكز
                        رعاية الأطفال، المدارس، المنازل، مواقع العمل، الرعاية
                        النهارية للبالغين، وكذلك العيادات التأهيلية في
                        المستشفيات والعيادات الخاصة.
                    </p>
                    <p>
                        كما أن لأخصائي العلاج الوظيفي دور هام في الفريق الطبي
                        التشخيصي لاضطراب طيف التوحد من خلال كشف التأخر النمائي
                        الحركي و الحسي.
                    </p>
                </>
            ) : (
                <>
                    <h4 id='title'>What is Applied Behavior Analysis?</h4>
                    <p>
                        It is a scientific approach to understand the behavior
                        using scientifically proven and evidence-based
                        practices. ABA refers to a set of principles that
                        focuses on how to change a behavior that is affected by
                        the surrounding environment, as well as how to create
                        opportunities for learning.
                    </p>
                    <p>
                        The term behavior also refers to the observable and
                        measurable skills associated with communication and
                        play. Applied behavior analysis program is a
                        comprehensive program based on the principles of applied
                        behavior analysis, many people from all over the world
                        use the ABA with children with autism spectrum disorder
                        from different age groups.
                    </p>
                    <h4 id='title'>
                        Interventions that are based on the ABA principles helps
                        to:
                    </h4>
                    <ul>
                        <li>
                            Increase and improve language and communication
                            skills.
                        </li>
                        <li>
                            Improve attention, focus, social and academic
                            skills.
                        </li>
                        <li>
                            Reducing and limiting problematic behaviors and
                            undesirable behaviors.
                        </li>
                    </ul>
                    <p>
                        ABA session also includes the use of several stages with
                        the flexibility to understand and change the behavior
                        and modify it through:
                    </p>
                    <ul>
                        <li>Designing programs to suit individual needs.</li>
                        <li>
                            Teaching important and supportive skills for
                            everyday life.
                        </li>
                        <li>
                            Delivering intervention in individual or group
                            sessions.
                        </li>
                    </ul>
                    <h4 id='title'>Targeted groups</h4>
                    <p>
                        The goal of the Applied Behavior Analysis Program at the
                        Center of Excellence is to provide the services for the
                        following different groups of society:
                    </p>
                    <h5 id='title'>
                        First: Children with autism spectrum disorder, by
                        creating an intensive and comprehensive individual
                        program that includes
                    </h5>
                    <ul>
                        <li>Teaching new skills and behaviors</li>
                        <li>Maintain appropriate behaviors</li>
                        <li>
                            Reducing and controlling interventional behaviors
                        </li>
                    </ul>
                    <h5 id='title'>
                        Second: Parents of children with autism spectrum
                        disorder by
                    </h5>
                    <ul>
                        <li>Providing consultations </li>
                        <li>
                            Providing training for parents on how to implement
                            the children programs and goals in the center and
                            generalize it to other environments
                        </li>
                    </ul>
                    <h5 id='title'>
                        Third: Specialists in the field of special education
                    </h5>
                    <p>
                        By offering intensive training courses about the applied
                        behavior analysis practices.
                    </p>
                    <p>
                        Despite the small number of certified therapists and
                        trainers in the field of applied behavior analysis, the
                        Center of Excellence is keen to provide the program
                        under the supervision of certified professionals from
                        the Board of BCBA.
                    </p>
                    <h4 id='title'>
                        The most prominent practices of applied behavior
                        analysis:
                    </h4>
                    <ul>
                        <li>Discrete Trial Training </li>
                        <li>Behavior Reduction Strategies </li>
                        <li>Verbal Behavior</li>
                        <li>Functional Behavior Assessment</li>
                        <li>The Picture Exchange Communication System</li>
                        <li>Functional Communication training </li>
                        <li>Prompting</li>
                        <li>
                            Natural Environment Training{' '}
                            <ul>
                                <li>Early Start Denver Model </li>
                                <li>
                                    Pivotal Response Training Incidental
                                    Teaching
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <h3 id='title'>Speech Language Pathology</h3>
                    <p>
                        The goal of treatment is to improve social communication
                        and other language skills and to modify behaviors so
                        that the individual is better able to develop
                        relationships, function effectively in social settings,
                        and actively participate in everyday life. SLPs often
                        collaborate with other professionals to design and
                        implement effective treatment plans.
                    </p>
                    <h4 id='title'>
                        Goals target core challenges of ASD and focus on
                    </h4>
                    <ul>
                        <li>
                            Initiating spontaneous communication in functional
                            activities;
                        </li>
                        <li>
                            Engaging in reciprocal communication interactions;
                            and
                        </li>
                        <li>
                            Generalizing skills across activities, environments,
                            and communication partners.
                        </li>
                    </ul>
                    <p>
                        Developmental sequences and processes of language
                        development provide a framework for determining
                        treatment baselines, adjusting goals, and tracking
                        progress. Core challenges of ASD take different forms as
                        an individual responds to intervention and progresses
                        through developmental stages from prelinguistic to
                        emerging language and advanced language stages.{' '}
                    </p>
                    <p>
                        The mode of communication used during treatment (e.g.,
                        spoken language, gestures, sign language, picture
                        communication, speech-generating devices [SGDs], and/or
                        written language) can vary, and more than one mode can
                        be used. Multimodal communication systems are
                        individualized according to the person&#39;s abilities
                        and the context of communication.
                    </p>
                    <h4 id='title'>Family-Centered Practice</h4>
                    <p>
                        The goal of <strong>family-centered</strong> practice is
                        to create a partnership so that the family fully
                        participates in all aspects of the individual&#39;s
                        care. Participation of families in services for the
                        individual with autism can help reduce the stress
                        experienced by family members.
                    </p>
                    <p>
                        Support may take different forms at different times and
                        may include coordinating services for the family,
                        procuring resources and information, teaching the family
                        or other significant communication partners specific
                        skills and strategies, providing learning opportunities,
                        and advocating for or with the family.{' '}
                    </p>
                    <h4 id='title'>Treatment Modes and Modalities</h4>
                    <p>
                        <strong>Treatment modes and modalities</strong> are
                        technologies or other support systems that the SLP can
                        use in conjunction with, or during implementation of,
                        various treatments. For example, the SLP can use
                        video-based instruction in peer-mediated interventions
                        to address social skills and other target behaviors.
                    </p>
                    <p>
                        A number of treatment modes and modalities are described
                        below. When selecting a mode or modality, the SLP
                        considers the intervention goal and the individual&#39;s
                        developmental stage. For example, a mode or modality
                        that is appropriate for an individual who is at the
                        emerging language stage may not be appropriate for an
                        individual who is at the prelinguistic stage. The list
                        below is not exhaustive, and inclusion does not imply an
                        endorsement from ASHA.
                    </p>
                    <h4 id='augmentative-and-alternative-communication-aac-'>
                        Augmentative and Alternative Communication (AAC)
                    </h4>
                    <h4 id='activity-schedule-and-visual-supports'>
                        Activity Schedule and Visual Supports
                    </h4>
                    <h4 id='computer-based-instruction'>
                        Computer-Based Instruction
                    </h4>
                    <h4 id='video-based-instruction'>
                        Video-Based Instruction
                    </h4>
                    <h4 id='title'>Treatment Approaches</h4>
                    <p>
                        Treatment approaches differ in the method used to
                        address goals—they range from discrete trial,
                        traditional behavioral approaches to social-pragmatic,
                        developmental approaches.
                    </p>
                    <p>
                        Approaches also differ in how goals are prioritized and
                        addressed. Focused interventions rely heavily on
                        individual strategies—used alone or in combination—to
                        target specific skills or behaviors (e.g., to increase
                        verbalization). Comprehensive interventions use multiple
                        strategies to target a broad range of skills or
                        behaviors (e.g., to enhance learning).
                    </p>
                    <p>
                        The selection of specific approaches takes into
                        consideration the level of social and linguistic
                        development, cultural background and values, personal
                        preferences, family resources, learning style, behavior
                        repertoire, and communication needs.
                    </p>
                    <h3 id='title'>Occupational Therapy</h3>
                    <p>
                        Occupational therapy (OT) is one of the key health
                        professions that work closely with individuals with
                        Autism. One key role for OT practitioners is supporting
                        early detection of autism and referral for services that
                        are associated with better outcomes such as early
                        intervention and Ayres sensory integration (CDC, 2016;
                        Zwaigenbaum, et al., 2015).
                    </p>
                    <p>
                        OT practitioners at Autism Center of Excellence (ACE)
                        provide client-centered, evidence-based services with
                        individuals of ASD to improve occupational performance
                        and participation in daily life.{' '}
                    </p>
                    <p>
                        Occupational therapy philosophy aligns with the evidence
                        that those with ASD thrive in an atmosphere that
                        emphasizes their strengths in the context of strong
                        client and family–professional partnerships (Dunn et
                        al., 2013).
                    </p>
                    <p>
                        OT intervention brings a unique perspective to client
                        services. American Occupational Therapy Association
                        states “Occupational therapy’s distinct value is to
                        improve health and quality of life through facilitating
                        participation and engagement in occupations, the
                        meaningful, necessary, and familiar activities of
                        everyday life” (AOTA, 2015).
                    </p>
                    <p>
                        OT Interventions at ACE are client-centered and
                        individualized in response to strengths and challenges
                        related to client factors, performance skills and
                        patterns, and the contextual factors of the environments
                        where the person lives, works, learns, and plays.
                    </p>
                    <p>
                        OT intervention planning for individuals with ASD at ACE
                        occurs after the holistic client-centered assessment
                        process.
                    </p>
                    <p>
                        Evidence-based practices that target outcomes in sensory
                        processing, academics, communication, higher cognitive
                        functions, interpersonal skills, learning readiness,
                        motor skills, personal responsibility, play, and
                        self-regulation are prioritized within our OT
                        intervention. This prioritization is consistent with
                        best practices recognized by AOTA (Tomchek &amp; Koenig,
                        2016) as well as guidelines of the National Professional
                        Development Center for Autism Spectrum Disorders (Wong
                        et. al, 2014) and the National Autism Center (2015).
                    </p>
                    <p>OT practitioners at ACE provide the following: </p>
                    <ul>
                        <li>
                            <p>
                                Evaluate an individual to determine whether he
                                or she has accomplished developmentally
                                appropriate skills needed in such areas as
                                grooming and play and leisure skills.
                            </p>
                        </li>
                        <li>
                            <p>
                                Provide interventions to help an individual
                                respond to information coming through the
                                senses. Intervention may include developmental
                                activities, sensory integration or sensory
                                processing, and play activities.
                            </p>
                        </li>
                        <li>
                            Facilitate play activities that instruct as well as
                            aid a child in interacting and communicating with
                            others.
                        </li>
                        <li>
                            Devise strategies to help the individual transition
                            from one setting to another, from one person to
                            another, and from one life phase to another.
                        </li>
                        <li>
                            Collaborate with the individual and family to
                            identify safe methods of community mobility.
                        </li>
                        <li>
                            Identify, develop, or adapt other daily activities
                            that are meaningful to enhance the individual’s
                            quality of life.
                        </li>
                    </ul>
                    <p>
                        Align with AOTA recommendations, OT practitioners at ACE
                        utilize standardized outcomes to measure the following:{' '}
                    </p>
                    <ul>
                        <li>
                            Client achievement of personally meaningful
                            relationships{' '}
                        </li>
                        <li>Success in skill performance </li>
                        <li>Management of daily life activities </li>
                        <li>
                            Participation in personal, social, environmental,
                            and cultural activities (AOTA, 2010).
                        </li>
                    </ul>
                </>
            )}
        </>
    );
}

export default Cure;
